import Endpoints from 'constants/Endpoints';
import {RestRequestPOST} from 'libs/RestRequest';
import PrivilegeService from "./PrivilegeService";

const RFX_PRIVILEGE_STORE_KEY = "rfx"

const cancelRound = async (roundId, comment) => {

    const body = {
        comment
    }
    const resp = await RestRequestPOST(Endpoints.RFX_ROUND_CANCEL(roundId), body);
    return resp;
}

const getBuyerPrivileges = async (roundId) => {
    await PrivilegeService.getPrivileges(Endpoints.RFX_ROUND_PRIVILEGES(roundId), PrivilegeService.RFX_PRIVILEGE_STORE_KEY);
}

export default {
    cancelRound,
    getBuyerPrivileges,
    RFX_PRIVILEGE_STORE_KEY
}